import React, { Component, Fragment } from "react";

import Content from "../../components/Content/ContentPage/Content";
import ContentHeader from "../../components/Content/ContentHeader/ContentHeader";
import Card from "../../components/Card/Card";
import MessageHandler from "../../components/MessageHandler/MessageHandler";
import { required, length } from "../../util/validators";
import Loader from "../../components/Loader/Loader";
import Newloader from "../../components/Loader/NewLoader/NewLoader";
import ErrorHandler from "../../components/ErrorHandler/ErrorHandler";
import WarrantyForm from "../../components/Variant/WarrantyForm/WarrantyForm";
import Paginator from '../../components/Paginator/Paginator';

import "./Warranty.css";

const POST_FORM = {
  title: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 2 })],
  },
  period: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required],
  },
  description: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 20 })],
  },
  categoryCode: {
    value: 0,
    valid: true,
    touched: true,
    errorMessage: "",
    validators: [],
  },
};

class Warranty extends Component {
  constructor(props) {
    super(props);

    this.state = {
      warranties: [],
      active: false,
      showMessage: false,
      code: 0,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
      totalWarranties: 0,
      perPage: 5,
      warrantyPage: 1,
      warrantiesLoading: true,
    };
  }

   componentDidMount() {
    this.loadWarranties(1);
  }

  
  toggleClass() {
    this.setState({
      active: this.state.active ? false : true,
      isEditing: false,
      editingData: {}
    });
  }

  onDeleteWarrantyHandler = (data) => {
    const Index = this.state.warranties.findIndex((p) => p.id === data.code);

    this.setState({
      code: data.code,
      showMessage: true,
      label: data.label,
      title: this.state.warranties[Index].title,
    });
  };

  onEditWarrantyHandler = (data) => {
    const Index = this.state.warranties.findIndex((p) => p.id === data.code);  
    
    this.setState({
      active: true,
      isEditing: true,
      editingData: this.state.warranties[Index]
    });

    // this.props.onEditHandler.bind(this, {
    //   code: this.state.code,
    //   label: this.state.label,
    // });
  };

  onCancelWarrantyHandler = () => {
    this.setState({
      code: 0,
      showMessage: false,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    });
  };
  onDeleteWarrantyTypeDicisionHandler = () => {
    this.props.onDeleteDataHandler({
      code: this.state.code,
      label: this.state.label,
    });
    this.setState({
      code: 0,
      showMessage: false,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    });    
  };


  onEditHandler = () => {
    this.setState({
      isEditing: true,
    });
  };
  onDeleteHandler = (data) => {
      const graphqlQuery = {
        query: `
        mutation {
          deleteWarranty(code: ${parseInt(data.code)})
        }
      `,
      };
      fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this.props.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(graphqlQuery),
      })
        .then((res) => {
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            throw new Error("خطا در حذف گارانتی!");
          }
          // this.newResetHandler();
          this.setState((prevState) => {
            let updatedPosts = [...prevState.warranties];
            const postIndex = prevState.warranties.findIndex(
              (p) => p.id === data.code
            );
            if (postIndex > -1) {
              updatedPosts.splice(postIndex, 1);
            }

            return {
              warranties: updatedPosts,
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ categoriesLoading: false });
        });        
  };

  loadWarranties = (warrantyPage) => {
    if (warrantyPage) {
      this.setState({ warrantiesLoading: true, warranties: [] });
    }

    const graphqlQuery = {
        query: `
          query FetchWarranties($page: Int, $perPage: Int) {
            allWarranties(page: $page, perPage: $perPage) {
              Warranties {
                id
                title
                period
                description
                isActive
              }
              totalWarranties
            }
          }
        `,
      variables: {
        page: warrantyPage,
        perPage: this.state.perPage
      }
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        console.log(resData);
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState({
            warranties: resData.data.allWarranties.Warranties,
            totalWarranties: resData.data.allWarranties.totalWarranties,
            warrantiesLoading: false,
            warrantyPage: warrantyPage 
        });
           
      })
      .catch(this.catchError);
  };

  acceptWarrantyChangeHandler = (postData) => {
    this.setState({
      editLoading: true,
    });
    
    
    let graphqlQuery;
    if (postData.editingCode !== 0) {
        graphqlQuery = {
          query: `
            mutation updatedWarranty($code: Int!, $categoryCode: Int!, $title: String!, $period: String!, $description: String!, $isActive: Boolean!) {
              updateWarranty(code: $code, warrantyInput: {categoryCode: $categoryCode, title: $title, period: $period, description: $description, isActive: $isActive}) {
                id
                title
                period
                description
                isActive
              }
            }
          `,
          variables: {
            code: parseInt(postData.editingCode),
            categoryCode: postData.categoryCode,
            title: postData.title,
            period: postData.period,
            description: postData.description,
            isActive: true,
          },
        };
    } else {
        graphqlQuery = {
          query: `
            mutation createNewWarranty($categoryCode: Int!, $title: String!, $period: String!, $description: String!, $isActive: Boolean!) {
              createWarranty(warrantyInput: {categoryCode: $categoryCode, title: $title, period: $period, description: $description, isActive: $isActive}) {
                id
                title
                period
                description
                isActive
              }
            }
          `,
          variables: {
            categoryCode: postData.categoryCode,
            title: postData.title,
            period: postData.period,
            description: postData.description,
            isActive: true,
          },
        };     
    }     

    return fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      body: JSON.stringify(graphqlQuery),
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        
        if (resData.errors && resData.errors[0].status === 422) {
          throw new Error(
            "Validation failed. Make sure the email address isn't used yet!"
          );
        }
        if (resData.errors) {
          throw new Error("ورود کاربر ناموفق!");
        }

        let resDataField = "createWarranty";
        if (postData.editingCode !== 0) {
          resDataField = "updateWarranty";          
        }

        var post = {
          id: resData.data[resDataField].id,
          title: resData.data[resDataField].title,
          period: resData.data[resDataField].period,
          description: resData.data[resDataField].description,
          isActive: resData.data[resDataField].isActive,
        };

        this.setState((prevState) => {
          let updatedTotalWarranties = prevState.totalWarranties;
          let updatedPosts = [...prevState.warranties];
          if (postData.editingCode !== 0) {
            const postIndex = prevState.warranties.findIndex(
              (p) => p.id == post.id
            );
            updatedPosts[postIndex] = post;
          } else {
            updatedTotalWarranties++;
            if (prevState.warranties.length >= prevState.perPage) {
              updatedPosts.pop();
            }
            updatedPosts.unshift(post);
          }

          return {
            active: false,
            warranties: updatedPosts,
            totalWarranties: updatedTotalWarranties
          };          
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isEditing: false,
          editWarranty: false,
          editLoading: false,
          error: err,
        });
      });
  };

  

  errorHandler = () => {
    this.setState({ error: null });
  };

  catchError = (error) => {
    this.setState({ error: error });
  };

  render() {
    return (
      <Fragment>
        <ErrorHandler error={this.state.error} onHandle={this.errorHandler} />
        <MessageHandler
          showMessage={this.state.showMessage}
          onHandle={this.onCancelWarrantyHandler}
          message={
            "آیا می‌خواهید گارانتی " +
            this.state.title +
            ' را حذف کنید؟'
          }
          onCancelModal={this.onCancelWarrantyHandler}
          onAcceptModal={this.onDeleteWarrantyTypeDicisionHandler}
          acceptMessage="تایید"
          cancelMessage="لغو"
        />
        <Content>
            <ContentHeader
              headerAction="درج گارانتی"
              headerDescription="اطلاعات گارانتی کالاها را در این صفحه وارد کنید"
            />
            <Card> 
                <span className="mn-promo-report__header-card-bold-title">جستجو و فیلتر</span>
                <div className="mn-card__body">
                    <form className="mn-ui-form" method="POST" id="searchForm" onSubmit={e => { e.preventDefault(); }}>
                        <div className="mn-ui-form__row mn-ui-form__row_padding">
                            <div className="mn-grid__row mn-grid__row--gap-lg mn-brand-card__footer">
                                <div className="c-ui-paginators">
                                    <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-12 mn-grid__col--xs-gap" style={{minWidth: '400px'}}>
                                        <label className="uk-form-label uk-flex uk-flex-between">جستجو:</label>
                                        <div className="field-wrapper ui-select ui-select__container">
                                            <div className="mn-ui-input">
                                                <input type="text" name="brand-search" className="mn-ui-input__field mn-ui-input__field--order" id="brand-search" placeholder="عبارت مورد نظرتان را وارد کنید..."/>
                                            </div>                                        
                                        </div>
                                    </div>
                                    <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom">
                                        <button className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active mn-search-btn--search-form mn-search_padding" id="submitButton">
                                            <span className="mn-seach__btn">جستجو</span>
                                        </button>
                                        <button type="button" className="mn-content-categories__search-reset" id="resetButton"></button>
                                    </div>
                                </div>
                                <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom">
                                    <button onClick={this.toggleClass.bind(this)} type="button" className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active--green mn-mega-campaigns__btns-green-plus mn-search_padding" id="submitButton">
                                        <span className="mn-seach__btn">ایجاد گارانتی جدید</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div
                      className={[
                        "mn-grid__row mn-brand__gap",
                        `${!this.state.active ? "uk-hidden" : ""}`,
                      ].join(" ")}
                    >
                      <WarrantyForm
                        toggleClass={this.toggleClass.bind(this)}
                        onAcceptModal={this.acceptWarrantyChangeHandler.bind( this )}
                        isEditing={this.state.isEditing}
                        editingData={this.state.editingData}
                        userId={this.props.userId}
                        token={this.props.token}
                      />
                    </div>             

                </div>
            </Card>
            <Card>
                <div className="c-card__wrapper">
                    <div className="mn-card__header mn-card__header--table">
                        <Paginator
                          onNext={this.loadWarranties.bind(this)}
                          lastPage={Math.ceil(this.state.totalWarranties / this.state.perPage)}
                          totalWarranties={this.state.totalWarranties}
                          currentPage={this.state.warrantyPage}
                        />
                    </div>
                    <div className={[ "c-card__body c-ui-table__wrapper", this.state.warrantiesLoading ? "c-content-loading" : "" ].join(" ")}>
                        <table className="c-ui-table   js-search-table " data-sort-column="" data-sort-order="asc" data-search-url="/commissions/search/" data-auto-reload-seconds="0" data-new-ui="1" data-is-header-floating="1" data-has-checkboxes="">
                            <thead>
                                <tr className="c-ui-table__row">
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="js-search-table-column">ردیف</span>
                                    </th>
                                
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">نام گارانتی</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">دوره گارانتی</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">توضیحات گارانتی</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">ویرایش گارانتی</span>
                                    </th>
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">حذف گارانتی</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.warranties !== [] && (
                                <Fragment>
                                    {this.state.warranties.map((data, index) => (
                                    <tr>
                                        <td className="c-ui-table__cell c-ui-table__cell--smaller">
                                        {index + 1}
                                        </td>
                                        <td className="c-ui-table__cell">{data.title}</td>
                                        <td className="c-ui-table__cell">{data.period}</td>
                                        <td className="c-ui-table__cell">{data.description}</td>
                                        
                                        <td className="c-ui-table__cell ">
                                          <span
                                              className="mn-link-row__status-ui edit"
                                              onClick={this.onEditWarrantyHandler.bind(this, {
                                              code: data.id,
                                              })}
                                          >
                                              {"ویرایش"}
                                              <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                          </span>
                                        </td>
                                        <td className="c-ui-table__cell">
                                          <span
                                              className="mn-link-row__status-ui delete"
                                              onClick={this.onDeleteHandler.bind(this, {
                                              code: data.id,
                                              })}
                                          >
                                              {"حذف"}
                                              <i className="fa fa-trash-o" aria-hidden="true"></i>
                                          </span>
                                        </td>
                                    </tr>
                                    ))}
                                </Fragment>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="c-card__footer">
                        <Paginator
                          onNext={this.loadWarranties.bind(this)}
                          lastPage={Math.ceil(this.state.totalWarranties / this.state.perPage)}
                          totalWarranties={this.state.totalWarranties}
                          currentPage={this.state.warrantyPage}
                        />
                    </div>
                    {this.state.warrantiesLoading && (
                      <div className="c-content-loader">
                        <Newloader/>
                      </div>
                    )} 
                </div>
            </Card>
        </Content>
      </Fragment>
    );
  }
}

export default Warranty;

